import React, { useState, useEffect } from 'react';

const AloeCamFeed = () => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  const handleFullscreen = () => {
    const videoElement = document.querySelector('.video-container');
    if (videoElement) {
      if (document.fullscreenElement) {
        document.exitFullscreen();
        setIsFullscreen(false);
      } else {
        videoElement.requestFullscreen();
        setIsFullscreen(true);
      }
    }
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };
    document.addEventListener('fullscreenchange', handleFullscreenChange);
    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
    };
  }, []);

  const getClientIP = async () => {
    try {
      const response = await fetch('https://api.ipify.org?format=json');
      const data = await response.json();
      return data.ip;
    } catch (error) {
      console.error('Error fetching IP:', error);
      return null;
    }
  };

  const startMotor1 = async () => {
    try {
      const clientIP = await getClientIP();
      console.log('Client IP:', clientIP);

      const url = clientIP
        ? `https://motor.altaran.us/motorOn?clientIP=${clientIP}`
        : `https://motor.altaran.us/motorOn`;

      const xhttp = new XMLHttpRequest();
      xhttp.onreadystatechange = function () {
        if (this.readyState === 4 && this.status === 200) {
          console.log(this.responseText);
        }
      };
      xhttp.open('GET', url, true);
      xhttp.send();
    } catch (error) {
      console.error('Error starting motor:', error);

      const xhttp = new XMLHttpRequest();
      xhttp.onreadystatechange = function () {
        if (this.readyState === 4 && this.status === 200) {
          console.log(this.responseText);
        }
      };
      xhttp.open('GET', 'https://motor.altaran.us/motorOn', true);
      xhttp.send();
    }
  };

  return (
    <div className="flex flex-col items-center justify-center text-center p-4 relative">
      <div className={`video-container w-full ${isFullscreen ? 'h-screen' : 'max-w-4xl'}`}>
        <img
          src="https://aloe.altaran.us"
          alt="AloeCam Live Feed"
          className={`w-full rounded-3xl border-4 border-white shadow-xl ${
            isFullscreen ? 'h-full object-contain' : ''
          }`}
          style={isFullscreen ? {} : { display: 'block', width: '100%', height: 'auto' }}
        />
      </div>

      {!isFullscreen && (
        <button
          onClick={handleFullscreen}
          className="mt-4 px-6 py-3 bg-purple-800 text-white rounded-lg hover:bg-purple-700 transition-colors duration-200 border border-purple-600 shadow-lg hover:shadow-xl"
        >
          Fullscreen
        </button>
      )}

      {isFullscreen && (
        <div className="fixed bottom-8 left-0 right-0 flex flex-col items-center space-y-4 z-10">
          <button
            onClick={startMotor1}
            className="px-6 py-3 bg-purple-800 text-white rounded-lg hover:bg-purple-700 transition-colors duration-200 border border-purple-600 shadow-lg hover:shadow-xl text-lg font-semibold"
          >
            Ball Drop!
          </button>
          <button
            onClick={handleFullscreen}
            className="px-6 py-3 bg-purple-800 text-white rounded-lg hover:bg-purple-700 transition-colors duration-200 border border-purple-600 shadow-lg hover:shadow-xl"
          >
            Exit Fullscreen
          </button>
        </div>
      )}
    </div>
  );
};

export default AloeCamFeed;
